module.exports = __webpack_public_path__ + "static/img/team_mode_photo.da2cba1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/pk/team_mode_photo.png
// module id = GRgD
// module chunks = 1